import { useState } from 'react';

/**
 * @desc Tab 数据
 */
type TFn = (str: string) => string;
export const useCreateOptions = (t: TFn, locale?: string) => {
    const [activeValue, setActiveValue] = useState<string>(['sa', 'za'] ? 'River2ProKit' : 'StarterKit');

    const solutionInfoMap: any = {
        us: [
            {
                id: 'StarterKit',
                name: t('secE_item1_title_1'),
                desc: t('secE_item1_title_4'),
            },
            {
                id: 'StarterKit1',
                name: t('secE_item4_title_1'),
                desc: t('secE_item4_title_4'),
            },
            {
                id: 'AdvancedKit',
                name: t('secE_item2_title_1'),
                desc: t('secE_item2_title_4'),
            },
            {
                id: 'SmartControlKit',
                name: t('secE_item3_title_1'),
                desc: t('secE_item3_title_4'),
            },
        ],
        ca: [
            {
                id: 'StarterKit1',
                name: t('secE_item4_title_1'),
                desc: t('secE_item4_title_4'),
            },
            {
                id: 'StarterKit2',
                name: t('secE_item5_title_1'),
                desc: t('secE_item5_title_4'),
            },
            {
                id: 'StarterKit',
                name: t('secE_item1_title_1'),
                desc: t('secE_item1_title_4'),
            },
            {
                id: 'AdvancedKit',
                name: t('secE_item2_title_1'),
                desc: t('secE_item2_title_4'),
            },
        ],
        sa: [
            {
                id: 'River2ProKit',
                name: t('secE_item3_title_1'),
                desc: t('secE_item3_title_4'),
            },
            {
                id: 'Delta2Kit',
                name: t('secE_item1_title_1'),
                desc: t('secE_item1_title_4'),
            },
            {
                id: 'DeltaProKit',
                name: t('secE_item2_title_1'),
                desc: t('secE_item2_title_4'),
            },
        ],
        za: [
            {
                id: 'River2ProKit',
                name: t('secE_item1_title_1'),
                desc: t('secE_item1_title_4'),
            },
            {
                id: 'Delta2Kit',
                name: t('secE_item2_title_1'),
                desc: t('secE_item2_title_4'),
            },
            {
                id: 'DeltaProKit',
                name: t('secE_item3_title_1'),
                desc: t('secE_item3_title_4'),
            },
        ],
        au: [
            {
                id: 'River2ProKit',
                name: t('secE_item1_title_1'),
                desc: t('secE_item1_title_4').split('\n')[0],
            },
            {
                id: 'Delta2Kit',
                name: t('secE_item2_title_1'),
                desc: t('secE_item2_title_4').split('\n')[0],
            },
            {
                id: 'DeltaProKit',
                name: t('secE_item3_title_1'),
                desc: t('secE_item3_title_4').split('\n')[0],
            },
        ],
    };

    return {
        activeValue,
        setActiveValue,
        solutionInfo: solutionInfoMap[locale || 'us'],
    };
};

/**
 * @desc 递归计算 offsetTop
 */
type PageTopType = (el: HTMLElement) => number;
const getElementToPageTop: PageTopType = (el) => {
    if (el.parentElement) {
        return getElementToPageTop(el.parentElement) + el.offsetTop;
    }

    return el.offsetTop;
};

/**
 * @desc 获取指定 id 元素至 document 文档顶部高度
 */
export const computedScrollTop = (domstr: string) => {
    const dom = document.querySelector(`#${domstr}`);
    let res = 0;
    if (dom) {
        res = getElementToPageTop(dom as HTMLElement);
    }
    return res + 1;
};
